import classnames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { barChartSeriesConfig } from './config';

type BarChartLegendItemProps = {
  color: string;
  id: string;
} & React.PropsWithChildren;

export const BarChartLegendItem: React.FC<BarChartLegendItemProps> = ({ color, children, id }) => (
  <div
    data-test-id={`adherence-history-detail:bar-chart-legend-item-${id}`}
    className="adherence-history__bar-chart__legend-item"
  >
    <span className="adherence-history__bar-chart__legend-item-circle" style={{ backgroundColor: color }} />
    {children}
  </div>
);

export const BarChartLegend: React.FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={classnames('adherence-history__bar-chart__legend', className)}>
      {barChartSeriesConfig.map(({ color, id, nameKey }) => (
        <BarChartLegendItem color={color} id={id} key={id}>
          {t(nameKey)}
        </BarChartLegendItem>
      ))}
    </div>
  );
};
